import React from "react";
import { FaHourglassHalf } from "react-icons/fa";
import { FcCancel } from "react-icons/fc";
import { MdVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { getApi } from "../pages/AppApis";
import { useEffect } from "react";
import { useState } from "react";
import VerificationRejectionReason from "./VerificationRejectionReason";

export default function VerificationPopup({ profileData, setVerificationPopupVisible }) {
    const navigate = useNavigate();
    const [verificationData, setVerificationData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [verificationReason, setVerificationReason] = useState(false);

    const getVerificationData = async () => {
        try {
            setLoading(true);
            const response = await getApi("/verifications/user-verifications", true);
            setVerificationData(response?.response.data.company_verifications);
        } catch (error) {
            console.error("Error fetching verification data:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        getVerificationData();
    }, []);

    return (
        <div
            onClick={() => setVerificationPopupVisible(false)}
            style={{ zIndex: 1500 }}
            className="tw-fixed tw-inset-0 tw-flex tw-items-center tw-justify-center tw-bg-black/50 tw-p-4 tw-min-h-screen"
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className="tw-bg-white tw-shadow-lg tw-rounded-[20px] tw-p-10 max-sm:tw-p-6 tw-w-full tw-max-w-lg max-sm:tw-max-w-[95vw] tw-max-h-[85vh] max-sm:tw-max-h-[80vh] tw-overflow-y-auto tw-my-auto"
            >
                <h3 className="tw-text-center tw-text-black tw-font-[700] tw-text-[28px] max-sm:tw-text-[24px]">Your Verifications</h3>
                <hr className="tw-mt-2 tw-mb-5 tw-w-full tw-bg-border_color tw-h-1" />
                {loading ? (
                    <div>Loading...</div>
                ) : (
                    <>
                        <div className="tw-flex tw-items-center tw-gap-3 tw-text-[16px] tw-font-[600] tw-text-black">
                            <p> Personal Verification:{"   "}</p>
                            <div className="tw-flex tw-items-center tw-gap-1">
                                {profileData.verification_status === "approved" ? (
                                    <>
                                        <span>
                                            <MdVerified color="#2bba00" />
                                        </span>
                                        <span className="tw-text-[#2bba00]">Verified</span>
                                    </>
                                ) : profileData.verification_status === "pending" ? (
                                    <>
                                        <span>
                                            <FaHourglassHalf color="#F2C94C" />
                                        </span>
                                        <span className="tw-text-[#F2C94C] tw-uppercase">{profileData.verification_status}</span>
                                    </>
                                ) : (
                                    <>
                                        <span>
                                            <FcCancel color="red" />
                                        </span>
                                        <span className="tw-text-[red] tw-uppercase">{profileData.verification_status}</span>
                                    </>
                                )}
                            </div>
                        </div>
                        <p className="tw-text-[16px] tw-font-[600] tw-text-black tw-mt-4"> Company Verification:{"   "}</p>
                        <ul className="tw-list-disc tw-pl-5 tw-mt-1">
                            {verificationData.map((item, index) => (
                                <>
                                    <li key={index} className="tw-flex tw-items-center tw-gap-1">
                                        <span className="tw-text-[16px] tw-font-[400] tw-text-black">{item.company_name}:</span>
                                        <span className="tw-text-[#2bba00] tw-flex tw-items-center tw-gap-1">
                                            {item.verification_status === "approved" ? (
                                                <>
                                                    <MdVerified color="#2bba00" />
                                                    Verified
                                                </>
                                            ) : item.verification_status === "pending" ? (
                                                <>
                                                    <FaHourglassHalf color="#F2C94C" />
                                                    <span className="tw-text-[#F2C94C]">Pending</span>
                                                </>
                                            ) : (
                                                <>
                                                    <FcCancel color="red" />
                                                    <span className="tw-text-[red]">Rejected</span>
                                                    <span
                                                        onClick={() => setVerificationReason(item.rejection_reason)}
                                                        className="tw-text-[red] tw-text-[10px] tw-underline tw-cursor-pointer"
                                                    >
                                                        View Reason
                                                    </span>
                                                </>
                                            )}
                                        </span>
                                    </li>
                                    <p></p>
                                </>
                            ))}
                        </ul>
                        <div className="tw-flex tw-items-center tw-justify-center">
                            <button
                                onClick={() => navigate("/start-verification")}
                                className="tw-bg-primary tw-mt-10 max-sm:tw-mt-6 tw-text-white tw-rounded-md tw-h-[48px] max-sm:tw-h-[44px] tw-flex tw-items-center tw-justify-center tw-w-[80%] max-sm:tw-w-[90%] tw-self-center max-sm:tw-text-sm"
                            >
                                Add Another Verification
                            </button>
                        </div>
                    </>
                )}
            </div>
            {verificationReason && (
                <VerificationRejectionReason
                    rejection_reason={verificationReason}
                    verificationStatus={"Rejected"}
                    setVerificationPopupVisible={setVerificationReason}
                />
            )}
        </div>
    );
}
